// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewsHeader-cls1___cbc730e51c313517dfc{/*!*/}.NewsHeader-cls2__dacb17c4beafe7366b1d{display:block;line-height:0;flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "NewsHeader-cls1___cbc730e51c313517dfc",
	"cls2": "NewsHeader-cls2__dacb17c4beafe7366b1d NewsHeader-cls1___cbc730e51c313517dfc"
};
export default ___CSS_LOADER_EXPORT___;
